__turbopack_context__.v({
  "loadingSpinner": "BtKONa_loadingSpinner",
  "spinLoaderContainer": "BtKONa_spinLoaderContainer",
  "spinner": "BtKONa_spinner",
});
